<script setup lang="ts">
import type { DeviceModel } from '@/types/models/DeviceModel'
import { TypographyWithPrefix } from '@rfc/rfc-components-library'

type Props = {
    data?: DeviceModel
    editMode?: boolean
}
defineProps<Props>()
</script>

<template>
    <TypographyWithPrefix
        :prefix="$t('device.model.eventName')"
        :label="data?.event?.name"
        boldLabel />
    <TypographyWithPrefix
        :prefix="$t('device.model.checkpointName')"
        :label="data?.checkpoint?.name"
        boldLabel />
</template>
